import scenePreLoader from './scene-pre-loader.module'
export default scenePreLoader
